module.exports = __webpack_public_path__ + "img/envio_ficheiros.3687bdd4.gif";